import { DefaultButton, Icon, IconButton, IIconProps } from 'office-ui-fabric-react';
import * as React from 'react'


interface IActionMenuButtonProps {
    title: string;
    icon: string;
    link: string;
    onClick?(): void;
}
  

const ActionMenuButton: React.FC<IActionMenuButtonProps> = ({ title, icon, link, onClick }) => {

  const iconProps: IIconProps = { iconName: icon, styles: { root: { fontSize: 35, marginRight: '10px' } } };

  return (
    <div className='action-button-wrapper'>
      <a href={link} style={{textDecoration: 'none'}}>
        <DefaultButton 
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
          styles={{root:{width: '100%', height: '5em', borderRadius: '12px', borderWidth: '2px', borderColor: '#C7a289'}}} title={title} aria-label={title} iconProps={iconProps}
        >
            {/* <Icon iconName={icon} style={{fontSize: "35px", marginRight: '10px'}} aria-hidden="true"></Icon> */}
            <span className="ms-Button-label" style={{fontSize: '14px', fontWeight: 400}}>{title}</span>
        </DefaultButton>
      </a>
    </div>
  )
}


export default ActionMenuButton
